var _defs, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionDetails(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 150",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        opacity: .7;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #66748f;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.02,71.12v2.59c0,.61-.5,1.11-1.11,1.11h-15.51c-.61,0-1.11-.5-1.11-1.11v-2.59c0-.61.5-1.11,1.11-1.11h15.51c.61,0,1.11.5,1.11,1.11ZM131.91,77.77h-15.51c-.61,0-1.11.5-1.11,1.11v2.59c0,.61.5,1.11,1.11,1.11h15.51c.61,0,1.11-.5,1.11-1.11v-2.59c0-.61-.5-1.11-1.11-1.11ZM141.89,60.4v30.66c0,2.45-1.99,4.43-4.43,4.43h-26.59c-2.45,0-4.43-1.99-4.43-4.43v-38.41c0-2.45,1.99-4.43,4.43-4.43h18.84c1.17,0,2.3.47,3.13,1.3l7.75,7.75c.83.82,1.3,1.96,1.3,3.13ZM130.07,53.01v7.03h7.03l-7.03-7.03ZM137.45,91.06v-26.59h-9.6c-1.23,0-2.22-.99-2.22-2.22v-9.6h-14.77v38.41h26.59Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 176.26,
    y: 82.68,
    width: 76.12,
    height: 28.96,
    rx: 11.2,
    ry: 11.2,
    transform: "translate(35.79 -56.13) rotate(16.26)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M115.28,24.67c-25.01,4.9-41.31,29.16-36.41,54.17,4.9,25.01,29.16,41.31,54.17,36.41,25.01-4.9,41.31-29.16,36.41-54.17-4.9-25.01-29.16-41.31-54.17-36.41ZM130.23,103.11c-17.85,3.5-35.15-8.13-38.65-25.98-3.5-17.85,8.13-35.15,25.98-38.65,17.85-3.5,35.15,8.13,38.65,25.98,3.5,17.85-8.13,35.15-25.98,38.65Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 167.16,
    y: 79.38,
    width: 14.13,
    height: 12.16,
    transform: "translate(37.1 -51.85) rotate(18.91)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionDetails);
export default __webpack_public_path__ + "static/media/transaction_details.30582b2bfee722c923165bdd1fd66ab0.svg";
export { ForwardRef as ReactComponent };